import React, { forwardRef } from 'react';
import FooterOfRentPrint from "./FooterOfRentPrint";
import TableScrolePrint from "./TableScrolePrint";

const AllSinglePrint = React.forwardRef((props, ref) => {
  return (
    <div ref={ref}>
      <TableScrolePrint />
      <br />
      <br />
      <FooterOfRentPrint />
    </div>
  );
});


export default AllSinglePrint;
